import { Skeleton } from '@/ui/components/skeleton/skeleton';

import { PlotSection } from '../plots/plot-section';

export type PlotSkeletonProps = {
  sectionName: string;
};
export function PlotSkeleton({ sectionName }: PlotSkeletonProps) {
  return (
    <PlotSection sectionName={sectionName}>
      <div className="min-w-[1000px]">
        {/* Simulate the disclosure title or section name */}
        <Skeleton className="mb-4 h-5 w-1/3" />
        <div className="flex flex-col gap-y-6">
          {/* Chart placeholders */}
          <Skeleton className="h-[400px]" />
        </div>
      </div>
    </PlotSection>
  );
}
